<div class="save-patient-modal__wrapper">
  <div class="save-patient-modal__body">
    <wl-patient-edit
      [defaults]="patient ?? undefined"
      [patientFiles]="patientFiles"
      [showMomentDirect]="showMomentDirectPatientFiles"
      [lockMomentDirect]="showMomentDirectPatientFiles"
      (formChanged)="onFormChange($event)"
      (patientFilesChanged)="onPatientFilesChanged($event)"
    />
  </div>

  <div class="save-patient-modal__footer">
    <p-button [disabled]="isSaving" severity="secondary" [label]="'general.close' | translate" (onClick)="onClose()" />
    <p-button
      [loading]="isSaving"
      [disabled]="isSaving || !form || form.invalid || !canSaveFiles"
      [label]="'general.save' | translate"
      severity="primary"
      (onClick)="onSave()"
    ></p-button>
  </div>
</div>
